import AbstractView from 'abstract';
import Vue from 'vue'
import store from 'definitions/store'
import storeInit from 'initializations/pages/CorporateRegisterPage'

export class Main extends AbstractView {
  constructor(domElementId) {
    return super(domElementId);
  }

  init() {
    storeInit.init("corporateRegister")

    const CorporateRegisterPage = () => import(/* webpackChunkName: "corporate-register-page" */ 'containers/Pages/Corporate/Register')

    new Vue({
      el: "#" + this.elemId,
      store,
      render: h => h(CorporateRegisterPage)
    })
  }
}
